import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';


const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative" style={{ minHeight: '100vh', width: '100%', backgroundColor: '#242423' }}>
      {/* 1. Background Video - Very Subtle, Plays Once, Stops on Last Frame */}
      <video
        autoPlay
        muted
        playsInline
        onEnded={(e) => { e.target.currentTime = e?.target?.duration; e?.target?.pause(); }}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: 0.12,
          zIndex: 0
        }}
      >
        <source src="/assets/videos/hero-bg.mp4" type="video/mp4" />
      </video>
      {/* 2. Gradient Fade Overlay - Same as other hero sections */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(to bottom, rgba(36, 36, 35, 0) 0%, rgba(36, 36, 35, 0.8) 100%)',
        zIndex: 1
      }} />
      {/* 3. Existing Content - DO NOT MODIFY */}
      <div className="relative min-h-[600px] md:min-h-[700px] lg:min-h-[800px] flex items-center justify-center px-4 md:px-6 lg:px-8 py-32" style={{ zIndex: 2 }}>
        {/* Background Grid Pattern */}
        <div className="absolute inset-0 opacity-[0.03]">
          <div className="absolute inset-0" style={{
            backgroundImage: `linear-gradient(var(--color-border) 1px, transparent 1px),
                             linear-gradient(90deg, var(--color-border) 1px, transparent 1px)`,
            backgroundSize: '48px 48px'
          }} />
        </div>

        {/* Content Container */}
        <div className="relative z-10 max-w-5xl mx-auto text-center">
          {/* Main Headline */}
          <h1 className="text-2xl font-semibold text-foreground mb-4 md:mb-6 lg:mb-8 leading-tight">
            Orchestrate Distributed Intelligence Across Cloud and Edge
          </h1>

          {/* Description */}
          <p className="text-base md:text-lg font-normal text-muted-foreground max-w-3xl mx-auto mb-8 md:mb-10 lg:mb-12 leading-relaxed">
            Sleeve coordinates autonomous agents, legacy systems, and human operators across industrial infrastructure—from factory floors to autonomous fleets, tactical networks to maritime operations.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-5 lg:gap-6">
            <Button
              variant="default"
              size="lg"
              iconName="ArrowRight"
              iconPosition="right"
              className="w-full sm:w-auto"
              onClick={() => navigate('/contact')}
            >
              Request a Live Platform Demo
            </Button>
            <Button
              variant="outline"
              size="lg"
              iconName="Layers"
              iconPosition="left"
              className="w-full sm:w-auto"
              onClick={() => navigate('/use-cases')}
            >
              Explore Use Cases
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;